module.exports = __webpack_public_path__ + "img/2026-09-21a_1.c8db37d2.jpg";